import { Route } from "vue-router";
import { getModule } from "vuex-module-decorators";
import TitleListState from "@/modules/title-list";

export const WordSpecRouteResolver = async function (to: Route, from: Route, next: Function) {
	const titleListModule = getModule(TitleListState);

	if (!titleListModule.levels.length) {
		await titleListModule.fetchVcsLevels();
	}

	next();
};
